































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import notificationService from '@/services/notificationService';

import {
  DxForm,
} from 'devextreme-vue/form';
import Popup from '@/components/default/Popup.vue';

import {
  ICreateContactCommand,
  IUpdateContactCommand,
  CreateContactCommand,
  UpdateContactCommand,
  IAddress,
  Address,
  AddressType,
  ContactsClient,
} from '@/data/web-api-client';

@Component({
  components: {
    Popup,
    DxForm,
  },
})
export default class AddOrUpdateContactDialog extends Vue {
  @Prop({required: false})
  private relationId?: string;

  @Prop({required: false})
  private projectId?: string;

  @Prop({required: false, default: ''})
  private contactId!: string;

  private show: boolean = false;
  private saving: boolean = false;
  private loading: boolean = false;

  private client: ContactsClient = new ContactsClient(undefined, this.$axios);

  private formdata: ICreateContactCommand | IUpdateContactCommand | any = {
    firstname: '',
    contantPaymentTerms: null,
    middlename: '',
    lastname: '',
    jobTitle: '',
    email: '',
    phone: '',
    mobile: '',
    language: '',
    nationality: '',
    nationalInsuranceNumber: '',
    socialSecurityNumber: '',
    dateOfBirth: undefined,
    birthLocation: '',
    team: '',
    tags: [],
    address: new Address({
      name: '',
      type: AddressType.Default,
      addressline1: '',
      addressline2: '',
      zip: '',
      city: '',
      country: '',
    }),
    id: '',
    disabled: false,
    notes: '',
    relationId: '',
    projectId: '',
    billingDetails: {
      discountPercentage: 0
    }
  };

  public async open() {
    this.formdata.projectId = this.projectId;
    this.formdata.relationId = this.relationId;

    this.show = true;

    setTimeout(async () => {
        try {
          if (!this.contactId || this.contactId === '') {
            return;
          }

          this.loading = true;
          const result = await this.client.getContactDetailed(this.contactId);
          Object.assign(this.formdata, result);
        } catch {
          // do sth
        } finally {
          this.loading = false;
        }
      }, 150);
  }

  private resetForm() {
    Object.assign(this.formdata, {
      firstname: '',
      contantPaymentTerms: null,
      middlename: '',
      lastname: '',
      jobTitle: '',
      email: '',
      phone: '',
      mobile: '',
      language: '',
      nationality: '',
      nationalInsuranceNumber: '',
      socialSecurityNumber: '',
      dateOfBirth: undefined,
      birthLocation: '',
      team: '',
      tags: [],
      address: new Address({
        name: '',
        type: AddressType.Default,
        addressline1: '',
        addressline2: '',
        zip: '',
        city: '',
        country: '',
      }),
      id: '',
      disabled: false,
      notes: '',
      relationId: '',
      projectId: '',
      billingDetails: {
        discountPercentage: 0
      }
    });
  }


  private async save() {
    try {
      const form: any = this.$refs.contactForm;
      const validationResult = form.instance.validate();

      if (validationResult.isValid) {
        this.saving = true;
        // save
        if (!this.contactId || this.contactId === '') {
          const res = await this.client.createContact(new CreateContactCommand(this.formdata));
          this.$emit('created', res);
        } else {
          const command = new UpdateContactCommand(this.formdata);
          command.init(this.formdata);

          const res = await this.client.updateContact(command);
          this.$emit('updated');
        }
        notificationService.saved();
        this.show = false;
        this.resetForm();
      } else {
        notificationService.invalidForm();
      }
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.saving = false;
    }
  }

  get languageOptions() {
    const list = this.$store.getters['catalogs/list']('Languages');
    let items = [];
    if (list) {
      items = list.values;
    }

    return {
        items,
      };
  }

  get tagsOptions() {
    const list = (this.$store.getters['catalogs/list']('CustomerTags'));
    let items = [];
    if (list) {
      items = list.values;
    }

    return {
      items,
    };
  }

  get formItems() {
    return [
      {
        itemType: 'group',
        colCount: 2,
        items: [
          {
            itemType: 'simple',
            label: {
              text: 'Voornaam',
            },
            isRequired: true,
            dataField: 'firstname',
            validationRules: [
              {type: 'required', message: 'Veld is verplicht'},
            ],
          },
          {
            itemType: 'simple',
            label: {
              text: 'Naam',
            },
            isRequired: false,
            dataField: 'lastname',
          },
          {
            itemType: 'simple',
            label: {
              text: 'Midden-naam',
            },
            isRequired: false,
            dataField: 'middlename',
          },
          {
            itemType: 'simple',
            label: {
              text: 'Jobtitel',
            },
            isRequired: false,
            dataField: 'jobTitle',
          },
          {
            itemType: 'group',
            items: [
              {
                itemType: 'simple',
                label: {
                  text: 'Email',
                },
                isRequired: false,
                dataField: 'email',
                validationRules: [
                  {type: 'email', message: 'Email is niet correct'},
                ],
              },
              {
                itemType: 'simple',
                label: {
                  text: 'Tel 1',
                },
                isRequired: false,
                dataField: 'phone',
              },
              {
                itemType: 'simple',
                label: {
                  text: 'Tel 2',
                },
                isRequired: false,
                dataField: 'mobile',
              },
            ],
          },
          {
            itemType: 'group',
            items: [
              {
                itemType: 'simple',
                label: {
                  text: 'Tags',
                },
                isRequired: false,
                dataField: 'tags',
                editorOptions: this.tagsOptions,
                editorType: 'dxTagBox',
              },
              {
                itemType: 'simple',
                label: {
                  text: 'Taal',
                },
                isRequired: false,
                dataField: 'language',
                editorOptions: this.languageOptions,
                editorType: 'dxLookup',
              },
            ],
          },
        ],
      },
      {
        itemType: 'tabbed',
        cssClass: 'tabBg',
        tabPanelOptions: {
          deferRendering: false,
        },
        tabs: [
          // ADDRESS
          {
            title: 'Adres',
            items: [
              {
                itemType: 'simple',
                dataField: 'address.addressline1',
                label: {
                  text: 'Straat + nr/bus',
                },
              },
              {
                itemType: 'simple',
                dataField: 'address.zip',
                label: {
                  text: 'Postcode',
                },
              },
              {
                itemType: 'simple',
                dataField: 'address.city',
                label: {
                  text: 'Gemeente',
                },
              },
              {
                itemType: 'simple',
                dataField: 'address.country',
                label: {
                  text: 'Land',
                },
              },
            ],
          },
          // IDENTITY INFORMATION
          {
            title: 'Identiteitsinformatie',
            items: [
              {
                itemType: 'simple',
                dataField: 'dateOfBirth',
                editorType: 'dxDateBox',
                editorOptions: { width: '100%' },
                label: {
                  text: 'Geboortedatum',
                },
              },
              {
                itemType: 'simple',
                dataField: 'birthLocation',
                label: {
                  text: 'Geboorteplaats',
                },
              },
              {
                itemType: 'simple',
                dataField: 'socialSecurityNumber',
                label: {
                  text: 'Social security number',
                },
              },
              {
                itemType: 'simple',
                dataField: 'nationalInsuranceNumber',
                label: {
                  text: 'Rijksregisternr.',
                },
              },
              {
                itemType: 'simple',
                dataField: 'nationality',
                label: {
                  text: 'Nationaliteit',
                },
              },
            ],
          },
          // Notes
          {
            title: 'Notities',
            items: [
              {
                itemType: 'simple',
                dataField: 'notes',
                editorType: 'dxTextArea',
                editorOptions: { height: 100 },
                label: {
                  text: 'Notities',
                  visible: false,
                },
              },
            ],
          },
          // Invoicing
          {
            title: 'Kortingen',
            items: [{
              itemType: 'simple',
              dataField: 'billingDetails.discountPercentage',
              editorType: 'dxNumberBox',
              label: {
                text: 'Korting (%)',
              },
            },
            ]
          }
        ],
      },
    ];
  }
}
